import { Table } from '@tanstack/react-table'
import { SortingOrder } from '../../SortingIconButton/SortingIconButton'

export const getColumnSorting = (table: Table<unknown>, columnId: string) => {
    const tableSorting = table.getState().sorting
    const columnSorting = tableSorting.find(
        (columnSorting) => columnSorting.id === columnId
    )
    const sorting: SortingOrder = columnSorting
        ? columnSorting.desc
            ? 'desc'
            : 'asc'
        : undefined

    return sorting
}
